/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { v4 as uuidv4 } from 'uuid';

/**
 * Namespace which provides functionality for GUID.
 */
export namespace Guid {
    export function generateGuid(): string {
        return uuidv4();
    }
}
